import { render, staticRenderFns } from "./ResearchGroupActForm.vue?vue&type=template&id=c42296b8&scoped=true"
import script from "./ResearchGroupActForm.vue?vue&type=script&lang=js"
export * from "./ResearchGroupActForm.vue?vue&type=script&lang=js"
import style0 from "./ResearchGroupActForm.vue?vue&type=style&index=0&id=c42296b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../.yarn/__virtual__/vue-loader-virtual-45869d479f/4/.yarn/berry/cache/vue-loader-npm-15.11.1-829412283a-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42296b8",
  null
  
)

export default component.exports